import { memo, useCallback, useState } from 'react'

import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'

import { ContactRelinkingFooterProps } from '../../models'
import { contactRelinkingModalTranslations } from '../../translation'
import { ContactRelinkingHeader } from '../contactRelinkingHeader'

import styles from './ContactRelinkingFooter.module.scss'

export const ContactRelinkingFooter = memo<ContactRelinkingFooterProps>(
  ({ onCancel, onProceed, isContinueDisabled }) => {
    const [isConfirmDialogVisible, setConfirmDialogVisible] = useState(false)

    const handleCancel = useCallback(() => {
      setConfirmDialogVisible(true)
    }, [])

    const handleConfirmCancel = useCallback(() => {
      setConfirmDialogVisible(false)
    }, [])

    const renderContent = useCallback(
      () => (
        <>
          <ContactRelinkingHeader
            title={contactRelinkingModalTranslations.cancelConfirm.title}
            description={contactRelinkingModalTranslations.cancelConfirm.description}
          />
          <div className={styles.confirmButtons}>
            <Button onClick={onCancel} color="danger" variant="text">
              <Translation
                text={contactRelinkingModalTranslations.cancelConfirm.buttons.cancel}
                span
              />
            </Button>
            <Button onClick={handleConfirmCancel}>
              <Translation
                text={contactRelinkingModalTranslations.cancelConfirm.buttons.confirm}
                span
              />
            </Button>
          </div>
        </>
      ),
      [handleConfirmCancel, onCancel]
    )

    return (
      <div className={styles.buttons}>
        <Button onClick={handleCancel} color="danger" variant="text">
          <Translation text={contactRelinkingModalTranslations.footer.buttons.cancel} span />
        </Button>
        <Button disabled={isContinueDisabled} onClick={onProceed}>
          <Translation text={contactRelinkingModalTranslations.footer.buttons.proceed} span />
        </Button>
        <ModalDialog
          classes={styles}
          size="xs"
          show={isConfirmDialogVisible}
          content={renderContent}
          onClose={handleConfirmCancel}
          closeOnOutsideClick={false}
        />
      </div>
    )
  }
)

ContactRelinkingFooter.displayName = 'ContactRelinkingFooter'
